import { GithubIcon } from './icons';

export const relatedLinks = [
  {
    icon: <GithubIcon />,
    title: 'Projeto-base',
    link: 'https://github.com/toeverything/AFFiNE',
  },
];
